// Change the college name here (and in Configuration > College Profile) to rebrand the whole admin website.
export const COLLEGE_NAME = 'College of Nursing';
export const COLLEGE_SHORT = 'CON';
export const PRODUCT_NAME = 'Nursing College Management System';
